import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { GeneralLoanTasks } from '../generalLoanTasks';
import { GeneralTasks } from '../generalTasks';
import { MyGeneralTeamTasks } from '../myGeneralTeamTasks';
import { MyGeneralTasksGmailPopup } from '../myGeneralTasksGmailPopup';
import { CreateTaskDialogInternal } from '../components/editTask/createTaskDialogInternal';
import { EditTaskDialogInternal } from '../components/editTask/editTaskDialogInternal';
import { SingleTaskViewInternal } from '../singleTaskViewInternal';
import { SingleTaskDetailViewInternal } from '../singleTaskDetailViewInternal';
import { AddLoanTaskInternalDialog } from '../components/addLoanTask/addLoanTaskInternalDialog';
import { MyGeneralTaskInternal } from '../myGeneralTaskInternal';
import { BrowseClosingConditionsTasks } from '../components/closingConditionsTasks/browseClosingConditionsTasks';


export const getGeneralTasksRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    tasksDashboard: {
      path: `${basePath}/tasks/all-tasks`,
      url: `${baseUrl}/tasks/all-tasks`,
      documentTitle: 'Tasks',
    },
    loanTasks: (loanId?) => ({
      path: `${basePath}/tasks/loan-tasks/:loanId`,
      url: `${baseUrl}/tasks/loan-tasks/${loanId}`,
      documentTitle: 'Tasks',
    }),
    myTasks: {
      path: `${basePath}/tasks/my-tasks`,
      url: `${baseUrl}/tasks/my-tasks`,
      documentTitle: 'Tasks',
    },
    myTeamTasks: {
      path: `${basePath}/tasks/my-team-tasks`,
      url: `${baseUrl}/tasks/my-team-tasks`,
      documentTitle: 'Team Tasks',
    },
    myTasksGmailPopup: {
      path: `${basePath}/tasks/my-tasks-gmail`,
      url: `${baseUrl}/tasks/my-tasks-gmail`,
      documentTitle: 'Tasks',
    },
    createTaskModal: (loanId?) => ({
      path: `${basePath}/tasks/create-task-modal/:loanId`,
      url: `${baseUrl}/tasks/create-task-modal/${loanId}`,
      documentTitle: 'Tasks',
    }),
    editTaskModal: (taskId?) => ({
      path: `${basePath}/tasks/edit-task-modal/:taskId`,
      url: `${baseUrl}/tasks/edit-task-modal/${taskId}`,
      documentTitle: 'Tasks',
    }),
    singleTask: (taskId?) => ({
      path: `${basePath}/tasks/single-task-modal/:taskId`,
      url: `${baseUrl}/tasks/single-task-modal/${taskId}`,
      documentTitle: 'Tasks',
    }),
    singleTaskDetails: (taskId?) => ({
      path: `${basePath}/tasks/single-task-details/:taskId`,
      url: `${baseUrl}/tasks/single-task-details/${taskId}`,
      documentTitle: 'Tasks',
    }),
    addLoanTaskModal: (loanId?) => ({
      path: `${basePath}/tasks/add-loan-task-modal/:loanId`,
      url: `${baseUrl}/tasks/add-loan-task-modal/${loanId}`,
      documentTitle: 'Tasks',
    }),
    closingConditions: {
      path: `${basePath}/tasks/closing-conditions`,
      url: `${baseUrl}/tasks/closing-conditions`,
      documentTitle: 'Closing Conditions',
    },
  };
};

export const getGeneralTasksRoutes = (basePath: string, baseUrl: string) => {
  const config = getGeneralTasksRoutesConfig(basePath, baseUrl);
  return {
    tasksDashboard: (
      <Route exact path={config.tasksDashboard.path}>
        <Page routeDefinition={config.tasksDashboard}>
          <GeneralTasks />
        </Page>
      </Route>
    ),
    loanTasks: (
      <Route exact path={config.loanTasks().path}>
        <Page routeDefinition={config.loanTasks()}>
          <GeneralLoanTasks />
        </Page>
      </Route>
    ),
    myTasks: (
      <Route exact path={config.myTasks.path}>
        <Page routeDefinition={config.myTasks}>
          <MyGeneralTaskInternal />
        </Page>
      </Route>
    ),
    myTeamTasks: (
      <Route exact path={config.myTeamTasks.path}>
        <Page routeDefinition={config.myTeamTasks}>
          <MyGeneralTeamTasks />
        </Page>
      </Route>
    ),
    myTasksGmailPopup: (
      <Route exact path={config.myTasksGmailPopup.path}>
        <Page routeDefinition={config.myTasksGmailPopup}>
          <MyGeneralTasksGmailPopup />
        </Page>
      </Route>
    ),
    createTaskModal: (
      <Route exact path={config.createTaskModal().path}>
        <Page routeDefinition={config.createTaskModal()}>
          <CreateTaskDialogInternal />
        </Page>
      </Route>
    ),
    editTaskModal: (
      <Route exact path={config.editTaskModal().path}>
        <Page routeDefinition={config.editTaskModal()}>
          <EditTaskDialogInternal />
        </Page>
      </Route>
    ),
    singleTaskModal: (
      <Route exact path={config.singleTask().path}>
        <Page routeDefinition={config.singleTask()}>
          <SingleTaskViewInternal />
        </Page>
      </Route>
    ),
    singleTaskDetails: (
      <Route exact path={config.singleTaskDetails().path}>
        <Page routeDefinition={config.singleTaskDetails()}>
          <SingleTaskDetailViewInternal />
        </Page>
      </Route>
    ),
    addLoanTaskModal: (
      <Route exact path={config.addLoanTaskModal().path}>
        <Page routeDefinition={config.addLoanTaskModal()}>
          <AddLoanTaskInternalDialog />
        </Page>
      </Route>
    ),
    closingConditions: (
      <Route exact path={config.closingConditions.path}>
        <Page routeDefinition={config.closingConditions}>
          <BrowseClosingConditionsTasks />
        </Page>
      </Route>
    ),
  };
};
